import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { BiMenu, BiShareAlt, BiArrowBack } from 'react-icons/bi';
import { BsEye } from 'react-icons/bs';
import { MdEditNote } from 'react-icons/md';
import { Button } from '../ui';
import ThemesToggle from '../../ThemesToggle';
import { LS_REDIRECT_URL_KEY } from '../../core/constants/common';
import Utils from '../../core/utilities/Utils';
import './builder-shell.scss';

const PreviewHeader = ({
  userFullName,
  formName,
  onToggleSidebar,
  sidebarOpen,
  onShare,
  onPublish,
  isPublished,
  canPublish,
  languageSelector,
}) => {
  const navigate = useNavigate();
  const { id, langId } = useParams();

  const goto = (path) => {
    if (!id) return;
    let url = `/form_builder/${path}/${id}`;
    if (langId) url += `/${langId}`;
    navigate(url);
  };

  // Mirrors App.js's legacy header Back button (hidden while the new
  // Builder/Preview is active) — see BuilderHeader.jsx for the same fix.
  const redirectUrl = localStorage.getItem(LS_REDIRECT_URL_KEY);

  const handleExit = () => {
    const url = Utils.getFormattedFormBuilderExitURL();
    if (!url) return;
    window.location.href = url;
  };

  return (
    <header className="builder-header">
      <div className="builder-header__left">
        {onToggleSidebar && (
          <Button
            variant="ghost"
            icon={<BiMenu />}
            aria-label="Toggle sidebar"
            aria-expanded={sidebarOpen}
            aria-controls="preview-sidebar"
            onClick={onToggleSidebar}
          />
        )}
        <span className="builder-header__project-name" title={formName}>
          {formName || 'Untitled Form'}
        </span>

      </div>

      <div className="builder-header__center" />

      <div className="builder-header__right">
        <div className="preview-mode-toggle" role="group" aria-label="Editor mode">
          <button
            type="button"
            className="preview-mode-toggle__btn"
            onClick={() => goto('form_edit')}
          >
            <MdEditNote aria-hidden="true" /> Build
          </button>
          <button
            type="button"
            className="preview-mode-toggle__btn preview-mode-toggle__btn--active"
            aria-current="page"
          >
            <BsEye aria-hidden="true" /> Preview
          </button>
        </div>
        {redirectUrl && (
          <Button
            type="button"
            variant="ghost"
            className="border"
            onClick={handleExit}
          >
            <BiArrowBack />
            Back
          </Button>
        )}
        {languageSelector}
        {canPublish && (
          <Button variant="primary" size="sm" onClick={onPublish}>
            Publish
          </Button>
        )}
        {isPublished && (
          <span className="preview-published-badge">Published</span>
        )}
        {/* <Button variant="ghost" icon={<BiShareAlt />} aria-label="Share form" onClick={onShare} /> */}
        {userFullName && (
          <span className="builder-text-secondary" style={{ fontSize: 14 }}>{userFullName}</span>
        )}
        <ThemesToggle />
      </div>
    </header>
  );
};

export default PreviewHeader;
